module.exports = __webpack_public_path__ + "static/media/Logo.d24845e1.png";